module.exports = __webpack_public_path__ + "img/Vernissage_PPAD_2017-5.8843ac6e.jpg";